import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createRestaurant } from "../../store/restaurant-slice";
import { restaurantSchema } from "../../schema/restaurantSchema";
import { getFormData } from "../../models/restaurantModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";

const RestaurantAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();

    const { createStatus, error } = useSelector(state => state.restaurant);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        dispatch(createRestaurant(data));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = restaurantSchema(); // Define this schema in your schema directory
    const initialData = getFormData(); // Define how initial data is fetched or structured

    return (
        <>
            <SubHeader title="Add Restaurant">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default RestaurantAdd;
